import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import KYC from '../components/KYC';
import Header from '../components/Header';
import Footer from '../components/Footer';
import * as actions from '../store/actions/index';
import Loader from '../components/shared/Loader';

const Wrapper = styled.div`
    font-family: ${props => props.theme.font};
    min-height: 100%;
    position: relative;
`;

class Home extends Component {
    state = {
        font: '',
        brand: '',
        footerTxt: '',
        stage: '',
    };

    componentDidMount() {
        const skipStatusCheck = this.props.location?.state?.fromMyInfo || false;
        const token = this.props.match.params.id;
        const { stage } = this.props.match.params;
        this.props.onStyleLoaded(token, skipStatusCheck);
        this.props.OnGetDropDownData();

        if (stage) {
            this.setState({
                stage,
            });
        }
    }

    render() {
        return (
            <>
                {this.props.brand ? (
                    <>
                        {this.props.brand === 'sgcm' && (
                            <Helmet>
                                <title>Sgcarmart Car Loan by Sgcarmart Financial Services</title>
                                <link rel="icon" type="image/x-icon" href="/sgcarmart-favicon.ico" />
                            </Helmet>
                        )}
                        <Wrapper>
                            <Header logo={this.props.logo} />
                            <KYC
                                stage={this.props.stage}
                                brand={this.props.brand}
                                sessionId={this.props.match.params.id}
                            />
                            <Footer text={this.props.footerTxt} />
                        </Wrapper>
                    </>
                ) : (
                    ''
                )}
                <Loader />
            </>
        );
    }
}
const mapStateToProps = state => {
    return { ...state.loadClientStyleReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        onStyleLoaded: (sessId, skipStatusCheck) => dispatch(actions.loadClientStyleStart(sessId, skipStatusCheck)),
        OnGetDropDownData: () => dispatch(actions.getDropDownDataStart()),
    };
};

Home.propTypes = {
    brand: PropTypes.string.isRequired,
    font: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    footerTxt: PropTypes.string.isRequired,
    mainBtn: PropTypes.object,
    outlineBtn: PropTypes.object,
    backBtn: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
